/** The three event-node kinds — shared by menu-label and predicate dispatch. */ export function isEventNodeKind(kind) {
    return kind === "event-start" || kind === "event-intermediate" || kind === "event-legacy";
}
/**
 * A node backed by a real recorded/draft entity — a step, decision, assignment
 * or event — whose `stableStepId` survives publish. These are exactly the nodes
 * the editor can delete through `onDeleteNodes` and the nodes a sticky note can
 * link to (ADR 0008). End/lane/synthetic-gateway nodes are derived (no backing
 * entity), and notes link/delete through their own handlers, so all four are
 * excluded.
 */ export function isBackingEntityKind(kind) {
    switch(kind){
        case "step":
        case "decision":
        case "assignment":
        case "event-start":
        case "event-intermediate":
        case "event-legacy":
            return true;
        case "note":
        case "empty-step":
        case "end":
        case "swimlane":
        case "synthetic-gateway":
            return false;
        default:
            {
                kind;
                return false;
            }
    }
}
/**
 * Read the `canvasKind` stamp off a canvas node. Throws when the stamp is
 * missing — every mint site stamps it, so a miss means a new mint site
 * skipped the stamp (a bug to surface loudly, not classify around).
 */ export function classifyCanvasNode(node) {
    const kind = node.data?.canvasKind;
    if (!kind) {
        throw new Error(`[process-flow] node "${node.id}" (type: ${String(node.type)}) carries no canvasKind stamp — stamp it at the mint site`);
    }
    return kind;
}

//# sourceMappingURL=nodeKind.js.map